import React from "react";
import ProductsPageLayout from "./ProductsPageLayout";

export default function AllProducts() {
  return (
    <>
      <ProductsPageLayout productCategory="general" />
    </>
  );
}
